// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".config_menu .link_value .tips[data-v-58853967] {\n  margin-top: 0.3125rem;\n  color: #999;\n  line-height: 1.5;\n  word-break: normal;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
